<app-task-list *ngIf="taskConfiguration" [taskListConfiguration]="taskConfiguration"></app-task-list>